export default __webpack_public_path__ + "static/media/instagram.5ffba1fe.svg";